import { Box } from '@skin-seoul/design-system';
import type { ComponentProps } from 'react';
import { useProductCard } from '../ProductCardContext';

export interface DiscountBadgeProps {
  backgroundColor?: ComponentProps<typeof Box>['backgroundColor'];
}

const DiscountBadge = ({ backgroundColor = 'primary.400' }: DiscountBadgeProps) => {
  const { originalPrice, salePrice } = useProductCard();

  if (!salePrice || salePrice >= originalPrice) {
    return null;
  }

  const discountPercentage = Math.round(((originalPrice - salePrice) / originalPrice) * 100);

  return (
    <Box
      position="absolute"
      top="0px"
      left="0px"
      scale="1.001"
      borderRadius="8px 0px"
      background={backgroundColor}
      color="white"
      padding="4px 6px"
      textStyle="label.medium"
      whiteSpace="nowrap"
    >
      {discountPercentage}% off
    </Box>
  );
};

export default DiscountBadge;
